import { Service } from "@/types";
import { atom } from "jotai";

const deliveryServiceAtom = atom<Service | null>(null)

export default deliveryServiceAtom
